module.exports = __webpack_public_path__ + "assets/img/blob-bg-special.dd6f028b.svg";